
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/tokushoho",
      function () {
        return require("private-next-pages/terms/tokushoho.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/tokushoho"])
      });
    }
  